import { Box, Button, Paper, Typography, styled } from '@mui/material';
import PhoneInput from 'react-phone-number-input';

export const ContainerFinProfile = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 4,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const ContainerPhone = styled(Paper)(({ theme }) => ({
  width: '650px',
  height: '296px',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

export const LabelPhone = styled(Typography)(({ theme }) => ({
  color: theme.palette.black.main,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
}));

export const StyledPhoneInput = styled(PhoneInput)`
  /* Override the input field's background color and border */
  .PhoneInputInput {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;
  }

  /* Change the focus outline color */
  .PhoneInputInput:focus {
    outline-color: #007bff;
  }

  /* Style the placeholder text */
  .PhoneInputInput::placeholder {
    color: #999;
  }

  /* Style the country select dropdown */

  /* Style the dropdown arrow icon */
  .PhoneInputCountryIcon {
    color: #333;
  }

  /* Override the dropdown options */
  .PhoneInputCountrySelectDropdownOption {
    padding: 8px;
    background-color: #fff;
    color: #333;
  }

  /* Change the hover background color for dropdown options */
  .PhoneInputCountrySelectDropdownOption:hover {
    background-color: #f5f5f5;
  }
`;

export const ButtonContinue = styled(Button)(({ theme }) => ({
  display: 'flex',
  width: '602px',
  height: '48px',
  padding: '7px 32px 9px 32px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flexShrink: '0',
  borderRadius: '44px',
  marginTop: theme.spacing(8),
}));

export const PhoneTitle = styled(Typography)(({ theme }) => ({
  color: 'rgba(97, 97, 97, 0.80)',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
  marginTop: '20px',
}));

export const LabelError = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
  marginTop: '20px',
}));
